import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isMobile } from 'react-device-detect';
import { Helmet } from 'react-helmet-async';
import { isAuthenticated } from './auth'


function _redirectToLogin() {
    return <Redirect to='/' />;
  }
  
  function _isAppRoute(props) {
    return props.match.path === '/app';
  }
  
  function _buildAppRouteContent(Component, props) {
    return <Component {...props}/>;
  }
  
  function _buildInnerRouteContent(Component, props) { 
    const url = props.location.pathname;
    const mainClass = url.replace('/app/', '');         
  
    const innerContentClass = isMobile ? 'col-xs-12' : 'col-xs-9';
  
    return (
      <div className={`viewport conteudo-interno ${mainClass} ${innerContentClass}`}>
        <Helmet title={`${process.env.REACT_APP_DOCUMENT_TITLE}`} />
        <div className={(!isMobile ? ' col-xs-9' : '')}>
          <Component {...props}/>
        </div>
      </div>
    ) 
  }
  
  export const PrivateRoute = ({ component: Component, ...rest }) => (
    
        <Route {...rest} render={(props) => {
  
          if (!isAuthenticated()) {
            return _redirectToLogin();
          }
          
          if (_isAppRoute(props)) {
            return _buildAppRouteContent(Component, props);
          }
            
          return _buildInnerRouteContent(Component, props);
              
        }} />  
    )
  
  export default PrivateRoute;